import { ClassList } from 'lib/utils/react/classlist';
import React from 'react';
import './labels.scss';

export type LabelColor = 'purple' | 'pink' | 'green' | 'blue' | 'orange' | 'red';

export type LabelProps = {
  label: string;
  description?: string;
  color?: LabelColor;
};

export const Label: React.FC<LabelProps> = ({
  label,
  description,
  color = 'purple'
}) => {
  const classes = ClassList.of('chip-label').add(color);
  return (
    <span className={classes.names} title={description}>
      {label}
    </span>
  );
};
